import React, { useEffect, useState, JSX } from 'react';
import { AiOutlineMenu, AiOutlineClose } from 'react-icons/ai';
import { FaHome, FaCar, FaTruck } from 'react-icons/fa';
import { GrDocumentText } from 'react-icons/gr';
import { MdAlternateEmail } from 'react-icons/md';
import Link from 'next/link';
import Image from 'next/image';
import appconfig from '@/utils/appConfig';
import { usePathname } from 'next/navigation';
import { NavItem } from './Header';

const ICON_SIZE = 24;

const menuIcons = {
    FaHome: <FaHome size={ICON_SIZE} className="mr-2" />,
    FaCar: <FaCar size={ICON_SIZE} className="mr-2" />,
    FaTruck: <FaTruck size={ICON_SIZE} className="mr-2" />,
    GrDocumentText: <GrDocumentText size={ICON_SIZE} className="mr-2" />,
    MdAlternateEmail: <MdAlternateEmail size={ICON_SIZE} className="mr-2" />,
};

interface MenuItemProps {
    icon: JSX.Element | undefined;
    label: string;
    route: string;
}

const MenuItem = ({ icon, label, route }: MenuItemProps) => {
    return (
        <li>
            <Link
                href={route}
                className="flex font-bold text-lg items-center bg-gray-100 hover:bg-gray-300 p-2 rounded-lg mb-4"
            >
                {icon} {label}
            </Link>
        </li>
    );
};

const MobileMenu = ({
    links,
    logoUrl,
}: {
    links: NavItem[];
    logoUrl: string | null;
}) => {
    const [isOpen, setIsOpen] = useState(false);

    const pathname = usePathname();

    useEffect(() => setIsOpen(false), [pathname]);

    return (
        <div className="max-w-[1640px] ml-auto flex justify-between items-center shadow-sm absolute right-4">
            {/* Hamburger Icon */}
            <div className="flex items-center">
                <div
                    onClick={() => setIsOpen(!isOpen)}
                    className="cursor-pointer"
                >
                    <AiOutlineMenu size={30} />
                </div>
            </div>

            {/* Mobile Menu */}
            {/* Overlay */}
            {isOpen ? (
                <div className="bg-black/80 fixed w-full h-screen z-30 top-0 left-0"></div>
            ) : (
                ''
            )}

            {/* Side drawer menu */}
            <div
                className={
                    isOpen
                        ? `${appconfig.colors.coloredSection} fixed top-0 left-0 w-[90%] h-screen z-30 duration-200 p-8 overflow-scroll`
                        : `${appconfig.colors.coloredSection} fixed top-0 left-[-100%] w-[90%] h-screen z-10 duration-200`
                }
            >
                <AiOutlineClose
                    onClick={() => setIsOpen(!isOpen)}
                    size={30}
                    className="absolute left-4 top-8 cursor-pointer"
                />
                <div className="mx-auto bg-white p-4 drop-shadow-2xl w-full rounded-lg mt-12">
                    <Link href="/" className="flex mx-auto">
                        <Image
                            unoptimized={true}
                            src={logoUrl as string}
                            height={76}
                            width={384}
                            alt="Penny Car Hire Logo"
                            layout="responsive"
                            className="mb-4"
                            objectFit="cover"
                        />
                    </Link>
                    <nav>
                        <ul className="flex flex-col text-gray-800">
                            <menu>
                                {links
                                    .filter((item) => item.mobileNav)
                                    .map((item) => (
                                        <MenuItem
                                            key={item.label}
                                            icon={
                                                menuIcons[
                                                    item.mobileMenuIcon as keyof typeof menuIcons
                                                ]
                                            }
                                            label={item.label || ''}
                                            route={item.path || ''}
                                        />
                                    ))}
                            </menu>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    );
};

export default MobileMenu;
